import {
    Action,
    Interpretation,
    IQueryTableResult,
    OperatorInvocation,
} from "#services/pilotService/types";
import { ApplicationState, IoState } from "#store/types";

export type ActionView = {
    action: Action;
    operators: OperatorInvocation[];
    interpretations: Interpretation[];
    tables: IQueryTableResult[];
};

export const selectActionById = (
    state: ApplicationState,
    id: number
): IoState<Action> => {
    return state.actions.actions[id];
};
